module.exports = __webpack_public_path__ + "img/img_qrCode_app.64246468.jpg";